import React from 'react';

const AuthedContext = React.createContext(null);

export const AuthedContextProvider = AuthedContext.Provider;
export default AuthedContext;
